export const apiEndpoint = process.env.REACT_APP_API_ENDPOINT || "/api/"
export const authEndpoint = process.env.REACT_APP_AUTH_ENDPOINT || "/"